var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.app.activeGroup.id == 9265)?_c('button',{class:`
        pos-fixed
        b-60
        r-20
        text-uppercase
        btn btn-lg btn-warning btn-icon
        rounded-pill
      `,on:{"click":_vm.showHelpButton}},[_c('feather',{staticClass:"ht-20-f wd-20-f",attrs:{"type":"help-circle"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }